import { render, staticRenderFns } from "./BlogHe.vue?vue&type=template&id=c6c34cf8&"
import script from "./BlogHe.vue?vue&type=script&lang=js&"
export * from "./BlogHe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports